import 'styles/main.scss';

import './login.module';



/** WEBPACK FOOTER **
 ** ./src/main/assets/app/login/login.entry.js
 **/